import React from 'react';

import { makeStyles, Typography } from '@material-ui/core';

const useStyles = makeStyles((theme) => ({
  typographyDetail: {
    color: '#999999',
    fontSize: '12px',
    lineHeight: '20px',
    marginBottom: '0px',
    textAlign: 'center',
  },
}));

export default () => {
  const classes = useStyles();

  return (
    <div style={{ textAlign: 'center' }}>
      <Typography className={classes.typographyDetail} style={{ marginBottom: '14px', marginLeft: 'auto', marginRight: 'auto', maxWidth: '430px' }}>
        Your radiology images and report are busy uploading to our system. Please keep this page open until you see that the upload has been successful.
      </Typography>
      <Typography className={classes.typographyDetail} style={{ marginLeft: 'auto', marginRight: 'auto', maxWidth: '360px' }}>
        This can take up to 10 minutes depending on the size of your files and internet connection speed.
      </Typography>
    </div>
  );
};
